<div class="upsell-buttons p-6 max-w-2xl mx-auto flex flex-col items-center">
  <button
    data-qa="cta-yes"
    class="upsell-buttons__button-yes w-full text-xl py-2.5 px-4 mb-4 text-white rounded-sm font-semibold"
    (click)="nextPage(true)"
    data-te="cta-yes"
    [innerHTML]="buttonYesText">
  </button>
  <button
    data-qa="cta-no"
    class="upsell-buttons__button-no w-full py-2.5 px-4 text-white rounded-sm font-semibold"
    (click)="nextPage(false)"
    [innerHTML]="buttonNoText"
    data-te="cta-no">
  </button>
</div>
